import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  AddDisclaimerObject,
  Disclaimer,
  Disclaimers,
} from "./disclaimers.interface";
import { AddonsResponse, TypedAddon } from "../addons.interface";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class DisclaimersService {
  constructor(private http: HttpClient) {}

  getDisclaimers = (): Observable<Disclaimers> => {
    return this.http.get<AddonsResponse>("/addons").pipe(
      map((addons) =>
        addons?.DISCLAIMER?.map((disclaimer) => ({
          addonId: disclaimer.addonId,
          modifiedAt: disclaimer.modifiedAt,
          isUsed: disclaimer.isUsed,
          usedInSignatures: disclaimer.usedInSignatures ?? [],
          ...disclaimer.data,
        })),
      ),
      map((disclaimers) => ({ disclaimers })),
    );
  };

  getDisclaimerById = (addonId: string): Observable<Disclaimer> => {
    return this.getDisclaimers().pipe(
      map((disclaimers) =>
        disclaimers.disclaimers.find(
          (disclaimer) => disclaimer.addonId === addonId,
        ),
      ),
    );
  };

  changeDisclaimer = (payload: Disclaimer): Observable<unknown> => {
    return this.http.put(`/addons/${payload.addonId}`, payload);
  };

  removeDisclaimer = (addonId: string): Observable<unknown> => {
    return this.http.delete(`/addons/${addonId}`);
  };

  addDisclaimer = (payload: AddDisclaimerObject): Observable<unknown> => {
    return this.http.post<TypedAddon<Disclaimer>>(`/addons`, payload).pipe(
      map((resp) => ({
        addonId: resp.addonId,
        ...resp.data,
      })),
    );
  };
}
